<template>
  <v-dialog width="850px" v-model="show" persistent>      
        <v-card class="pa-4">
            <v-flex md12 xs12 class="pt-3">
                <span
                    class="subheading grey--text text--darken-1 mx-3"
                    for="url_img"                    
                >Tipo do rateio:</span>
                <v-radio-group                    
                    hide-details
                    v-model="rateio"
                    row
                    class="mt-2 mx-3"
                    @click="setRateio()"
                >
                    <v-radio label="Personalizado" value="CUSTOM"></v-radio>
                    <v-radio label="Igualitário" value="EGALITARIAN"></v-radio>
                    <v-radio label="Automatico" value="AUTO"></v-radio>                    
                </v-radio-group>
                <v-divider></v-divider>
                <span
                    style="text-align: justify"
                    class="subheading grey--text text--darken-1 mx-3"
                    for="url_img"                    
                >{{description()}}</span>
            </v-flex>                        
            <v-flex xs12 class="my-4 mx-1" v-if="rateio == 'CUSTOM' || rateio == 'EGALITARIAN'">                                                    
                <v-layout
                    row
                    wrap
                    class="mx-3"
                    v-for="(user, index) in users"
                    :key="index"
                    :value="user.id"
                >
                    <v-flex xs3>
                        <span class="font-weight-medium subheading">{{ user.name }}</span>
                    </v-flex>     
                    <v-flex xs12 md4 class="pr-2">                        
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text font-weight-medium" id="basic-addon1">%</span>
                            </div>
                            <input
                                class="form-control"
                                v-mask="'###'"
                                v-model="user.percentage_apportionment"
                                :disabled="(rateio == 'CUSTOM' ? false : true)"
                            />
                        </div>
                    </v-flex>        
                </v-layout>    
            </v-flex>
            <v-flex xs12 class="text-xs-right">
                <v-btn class="grey white--text" @click="$emit('close')">Cancelar</v-btn>
                <v-btn
                    class="success white--text"
                    :disabled="( false )"
                    @click="save()"
                >Salvar</v-btn>
            </v-flex>
      </v-card>
  </v-dialog>
</template>

<script>
import UserController from "../../controllers/UserController"
export default {
    props: {
        clientId: Number,
        show: Boolean
    },
    async created(){
        await this.getUsersByClient()
    },
    data(){
        return{
            userController: new UserController(this.$resource),
            users: [],
            rateio: 'AUTO'
        }
    },
    methods: {
        description(){
            if(this.rateio == 'CUSTOM')
                return 'O administrador do programa, poderá distribuir a porcentagem do valor a ser pago por cada usuário.'
            if(this.rateio == 'AUTO')
                return 'Distribuição será automatica, proporcional a quantidade de tempo utilizada por cara usuário do programa.'
            if(this.rateio == 'EGALITARIAN')
                return 'Distribuição será igualitária, ou sejá todos os usuários pagam a mesma pocentagem do valor.'
        },
        setRateio(){            
            if(this.rateio != 'AUTO'){
                this.users.reduce( (acumulador, item, indice, array) => {                
                    if( indice + 1 == array.length){
                        item.percentage_apportionment = acumulador;
                        return acumulador - acumulador
                    } else {
                        item.percentage_apportionment = parseInt(100 / this.users.length)
                        return acumulador - item.percentage_apportionment
                    }                
                },100)                
            }else{
                this.users.map( item => {
                    item.percentage_apportionment = null
                })
            }
        },
        save(){
            try {
                if(this.rateio != 'AUTO'){
                    let apportionment = 0;
                    this.users.map( (item) => {                        
                        apportionment += parseInt(item.percentage_apportionment);
                    })                                       
                    if(apportionment != 100)
                        throw "Erro ao destrubuir valores, a soma dos valores deve ser exatamente igual a 100."                
                }
                this.$emit('activeProgram', this.users, this.rateio)
            } catch (error) {
                this.$awn.alert(error)
            }
        },
        getUsersByClient(){
            this.userController.getActiveByClientId(this.clientId)
                .then(  res => {               
                    if(res.length > 0){
                        res.map( item => {
                            this.users.push({ 
                                user_id: item.id,
                                name: item.name,
                                percentage_apportionment: null
                            })    
                        })
                    }else{
                        this.$awn.alert('Por favor cadastre pelo menos 1 usuário para ativar o programa.')
                        this.$emit('close')
                    }                                             
                })
        }
    }
}
</script>

<style>

</style>